import Sokanzu from "./_sokanzu.es6";

const sokanzu = new Sokanzu();